// eslint-disable-next-line import/namespace
import axios from 'axios'
import {formatDateTimeDMY} from '@/utils/date';


export default {
    state: {
        logs: [],
    },

    mutations: {
        SET_LOGS(state, payload) {
            state.logs = payload
        },
    },

    getters: {
        filterLogs(state) {
            return state.logs.map((log) => ({
                id: log.id,
                title: log.message || 'Sem descrição',
                link: {name: 'logs.show', params: {id: log.id}},
                status_text: log.action === 'insert' ? 'Inserção' : 'Ação',
                status: 'approved',
                content_left: `${log.user.name} - ${log.user.email}`,
                content_right_bottom: formatDateTimeDMY(log.created_at),
            }))
        },
        getLogById: (state) => (id) => {
            return state.logs.find(todo => todo.id === id)
        },
    },

    actions: {
        getLogs({commit}) {
            return new Promise((resolve) => {
                return axios.get('v1/logging/search')
                    .then((response) => {
                        commit('SET_LOGS', response.data.data)
                        resolve()
                    })
            })
        },
    },
}